import * as React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Divider, TableRow, TableCell, TableContainer, Paper, Table, TableHead, TableBody, IconButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CampaignSource = (props) => {
  const theme = useTheme();
  const { sourceProfession, professions } = props;

  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState([]);

  useEffect(() => {
    if (professions !== undefined) {
      if (professions.length > 0) {
        const tempRows = [];
        const total = { id: 1000, name: 'Total' };
        professions.forEach((prof) => {
          total[prof.profession] = { general: 0 };
        });
        let subTotalHRowGeneral = 0;
        
        Object.keys(sourceProfession).forEach((source) => {
          let row = { id: source, name: source };
          const totalHRow = { general: 0 };
          professions.forEach((profession) => {
            row[profession.profession] = sourceProfession[source][profession.profession] === undefined ? { general: 0 } : sourceProfession[source][profession.profession];
            total[profession.profession].general += sourceProfession[source][profession.profession] === undefined ? 0 : sourceProfession[source][profession.profession].general;
            totalHRow.general += sourceProfession[source][profession.profession] === undefined ? 0 : sourceProfession[source][profession.profession].general;
          });
          subTotalHRowGeneral += totalHRow.general;

          // partie historique
          const historic = {};
          Object.keys(sourceProfession[source].historique).forEach((date) => {
            historic[date] = sourceProfession[source]['historique'][date];
            let totalNumber = 0;
            Object.keys(sourceProfession[source]['historique'][date]).forEach((data) => {
              totalNumber += sourceProfession[source]['historique'][date][data].general;
            });
            historic[date].total = { general: totalNumber };
          });

          row = { ...row, totalH: totalHRow, historic };
          tempRows.push(row);
        });
        total.totalH = { general: subTotalHRowGeneral };
        tempRows.push(total);

        setRows(tempRows);
      }
    }
  }, [professions, sourceProfession]);

  const handleOpen = (index) => {
    const tempOpen = [...open];
    tempOpen[index] = !tempOpen[index];
    setOpen(tempOpen);
  };

  return (
    <Card
      sx={{
        borderRadius: '24px',
        boxShadow: '0 4px 18px 0 rgba(0,0,0,0.03)',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255,255,255,0.08)',
        overflow: 'hidden'
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ p: 2.5, fontWeight: 700, color: theme.palette.text.primary }}
      >
        Nombre de prospects par profession et par statut
      </Typography>
      <Divider />
      <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent' }}>
        <Table aria-label="simple table">
          <TableHead
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)',
              borderBottom: `2px solid ${theme.palette.divider}`
            }}
          >
            <TableRow>
              <TableCell sx={{ width: 60 }} />
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Statut
              </TableCell>
              {professions.map((profession) => (
                <TableCell
                  key={profession.profession}
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  {profession.profession}
                </TableCell>
              ))}
              <TableCell
                align="right"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Total
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <React.Fragment key={row.name || row.id}>
                <TableRow
                  sx={{
                    '& > *': { borderBottom: 'unset' },
                    borderBottom: 'unset',
                    transition: 'background-color 0.2s ease',
                    backgroundColor: row.name === 'Total' ? (theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)') : 'inherit',
                    '&:hover': {
                      backgroundColor: row.name === 'Total' ? '' : (theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.02)' : 'rgba(255, 255, 255, 0.02)')
                    }
                  }}
                >
                  <TableCell sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleOpen(index)}
                    >
                      {open[index] && row.name !== 'Total' ? <KeyboardArrowUpIcon /> : !open[index] && row.name !== 'Total' ? <KeyboardArrowDownIcon /> : ''}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                  >
                    <Typography
                      sx={{
                        fontWeight: row.name === 'Total' || open[index] ? 700 : 500,
                        fontSize: open[index] && row.name !== 'Total' ? '1.1rem' : '0.875rem',
                        color: theme.palette.text.primary
                      }}
                    >
                      {row.name}
                    </Typography>
                  </TableCell>
                  {professions.map((profession) => (
                    <TableCell
                      key={profession.profession}
                      align="right"
                      sx={{
                        py: 1.5,
                        fontWeight: row.name === 'Total' ? 700 : 500,
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                      }}
                    >
                      {row[profession.profession] === null ? 0 : row[profession.profession].general}
                    </TableCell>
                  ))}
                  <TableCell
                    align="right"
                    sx={{
                      py: 1.5,
                      fontWeight: 700,
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                    }}
                  >
                    {row.totalH.general === undefined ? 0 : row.totalH.general}
                  </TableCell>
                </TableRow>
                <TableRow>
                  {row.name !== 'Total' && (
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={professions.length + 3}
                      sx={{ borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                    >
                      <Collapse
                        in={open[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ margin: 2, p: 2, borderRadius: '16px', border: '1px solid', borderColor: theme.palette.divider, backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)' }}>
                          <Typography
                            variant="subtitle2"
                            gutterBottom
                            component="div"
                            sx={{ fontWeight: 700, mb: 2, color: theme.palette.primary.main }}
                          >
                            Historique des réinjections
                          </Typography>
                          <Table size="small" aria-label="purchases">
                            <TableHead
                              sx={{
                                backgroundColor: theme.palette.mode === 'light' ? '#fff' : 'rgba(0,0,0,0.1)',
                                borderBottom: `2px solid ${theme.palette.divider}`
                              }}
                            >
                              <TableRow>
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Niveau de réinjection
                                </TableCell>
                                {professions.map((profession) => (
                                  <TableCell
                                    key={profession.profession}
                                    align="right"
                                    sx={{
                                      fontWeight: 700,
                                      color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                      fontSize: '0.75rem'
                                    }}
                                  >
                                    {profession.profession}
                                  </TableCell>
                                ))}
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Total
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.historic !== undefined && (
                                Object.keys(row.historic).map((histoData) => (
                                  <TableRow key={histoData} hover>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
                                      {histoData}
                                    </TableCell>
                                    {Object.keys(row.historic[histoData]).map((status) => (
                                      <TableCell key={status} align="right" sx={{ color: theme.palette.text.secondary }}>
                                        {row.historic[histoData][status] === undefined || row.historic[histoData][status].general === null ? 0 : row.historic[histoData][status].general}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

CampaignSource.propTypes = {
  sourceProfession: PropTypes.object.isRequired,
  professions: PropTypes.array.isRequired,
};

export default CampaignSource;
